export default "__VITE_ASSET__DFs7VXX4__"